import Icon from '@ant-design/icons'

const SVG = () => (
    <svg
        t='1653650971320'
        className='icon'
        viewBox='0 0 1024 1024'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        p-id='13661'
    >
        <path
            d='M379.333 766.69c0 8.413-6.523 17.493-14.498 20.178l-198.994 67.001c-7.973 2.684-14.498-2.003-14.498-10.416v-567.724c0-8.413 6.523-17.493 14.498-20.178l198.994-67.001c7.973-2.685 14.498 2.003 14.498 10.416v567.724z'
            p-id='13662'
            fill='currentColor'
        ></path>
        <path
            d='M872.654 766.69c0 8.413-6.524 17.493-14.498 20.178l-198.993 67.001c-7.974 2.684-14.498-2.003-14.498-10.416v-567.724c0-8.413 6.523-17.493 14.498-20.178l198.993-67.001c7.973-2.685 14.498 2.003 14.498 10.416v567.724z'
            p-id='13663'
            fill='currentColor'
        ></path>
        <path
            d='M398.006 766.69c0 8.413 6.523 17.493 14.498 20.178l198.993 67.001c7.974 2.684 14.497-2.003 14.497-10.416v-567.724c0-8.413-6.523-17.493-14.497-20.178l-198.993-67.001c-7.973-2.685-14.498 2.003-14.498 10.416v567.724z'
            p-id='13664'
            fill='currentColor'
        ></path>
    </svg>
)

export const MapIcon = props => <Icon component={SVG} {...props} />
